/*=============================================== FormPage ===============================================*/

import { useState } from "react"
import type { ChangeEvent, FormEvent } from "react"
import { Form, Input } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import { commonProps, propAllLinks } from "data"

const FormPage = () => {
    const [inputs, setInputs] = useState({
        name: "",
        email: "",
        password: "",
    })

    const handleInputs = (e: ChangeEvent<HTMLInputElement>) =>
        setInputs({
            ...inputs,
            [e.target.id]: e.target.value,
        })

    const resetForm = () =>
        setInputs({
            name: "",
            email: "",
            password: "",
        })

    const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        alert(JSON.stringify(inputs))
    }

    const items: ItemType[] = [
        {
            content: (
                <Form
                    buttonPrimary={{ text: "Submit", iconLeft: "send" }}
                    buttonSecondary={{ onClick: resetForm }}
                    onSubmit={handleSubmit}
                >
                    <Input
                        id="name"
                        label="Name"
                        onChange={handleInputs}
                        value={inputs.name}
                    />
                    <Input
                        id="email"
                        label="Email"
                        type="email"
                        onChange={handleInputs}
                        value={inputs.email}
                    />
                    <Input
                        id="password"
                        label="Password"
                        password
                        onChange={handleInputs}
                        value={inputs.password}
                    />
                </Form>
            ),
            code: 'const [inputs, setInputs] = useState({\n    name: "",\n    email: "",\n    password: "",\n})\n\nconst handleInputs = e =>\n    setInputs({\n        ...inputs,\n        [e.target.id]: e.target.value,\n    })\n\nconst resetForm = () =>\n    setInputs({\n        name: "",\n        email: "",\n        password: "",\n    })\n\nconst handleSubmit = e => {\n    e.preventDefault()\n    alert(JSON.stringify(inputs))\n}\n\n<Form buttonPrimary={{ text: "Submit", iconLeft: "send" }} buttonSecondary={{ onClick: resetForm }} onSubmit={handleSubmit}>\n    <Input id="name" label="Name" onChange={handleInputs} value={inputs.name} />\n    <Input id="email" label="Email" type="email" onChange={handleInputs} value={inputs.email} />\n    <Input id="password" label="Password" password onChange={handleInputs} value={inputs.password} />\n</Form>',
            codeTs: 'const [inputs, setInputs] = useState({\n    name: "",\n    email: "",\n    password: "",\n})\n\nconst handleInputs = (e: ChangeEvent<HTMLInputElement>) =>\n    setInputs({\n        ...inputs,\n        [e.target.id]: e.target.value,\n    })\n\nconst resetForm = () =>\n    setInputs({\n        name: "",\n        email: "",\n        password: "",\n    })\n\nconst handleSubmit = (e: FormEvent<HTMLFormElement>) => {\n    e.preventDefault()\n    alert(JSON.stringify(inputs))\n}\n\n<Form buttonPrimary={{ text: "Submit", iconLeft: "send" }} buttonSecondary={{ onClick: resetForm }} onSubmit={handleSubmit}>\n    <Input id="name" label="Name" onChange={handleInputs} value={inputs.name} />\n    <Input id="email" label="Email" type="email" onChange={handleInputs} value={inputs.email} />\n    <Input id="password" label="Password" password onChange={handleInputs} value={inputs.password} />\n</Form>',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "isLoading",
            type: "boolean",
        },
        "separator",
        {
            subtitle: "buttonPrimary",
            intro: (
                <>
                    Used as a string, this changes the text on the{" "}
                    <code>primary</code> button.
                </>
            ),
            type: "string or object",
        },
        {
            title: (
                <>
                    <code>buttonPrimary</code> object
                </>
            ),
            subtitle: "text",
            type: "string",
            required: true,
        },
        {
            subtitle: "iconLeft",
            intro: commonProps.addIconCapital,
            type: "string",
        },
        {
            subtitle: "iconRight",
            type: "string",
        },
        "separator",
        {
            subtitle: "buttonSecondary",
            type: "object",
        },
        {
            title: (
                <>
                    <code>buttonSecondary</code> object
                </>
            ),
            subtitle: "text",
            type: "string",
            default: (
                <>
                    Depending on the other props, if you add a <code>to</code>:{" "}
                    <code>Cancel</code>, if it's an <code>onClick</code>:{" "}
                    <code>Reset</code>
                </>
            ),
        },
        {
            subtitle: "onClick",
            type: "function",
        },
        ...propAllLinks,
        {
            subtitle: "iconLeft",
            type: "string",
        },
        {
            subtitle: "iconRight",
            type: "string",
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default FormPage
